import type { RegistryEntry } from "../../shared.ts";

export const syntheticProvider: RegistryEntry = {
  id: "synthetic",
  alias: "synthetic",
  format: "openai",
  executor: "default",
  baseUrl: "https://api.synthetic.new/openai/v1/chat/completions",
  modelsUrl: "https://api.synthetic.new/openai/v1/models",
  authType: "apikey",
  authHeader: "bearer",
  models: [
    {
      id: "hf:openai/gpt-oss-120b",
      name: "openai/gpt-oss-120b",
      aliases: ["syn:gpt-oss-120b"],
      contextLength: 131072,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
    },
    {
      id: "hf:zai-org/GLM-5.2",
      name: "zai-org/GLM-5.2",
      aliases: ["syn:large:text"],
      contextLength: 524288,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
    },
    {
      id: "hf:moonshotai/Kimi-K2.7-Code",
      name: "moonshotai/Kimi-K2.7-Code",
      aliases: ["syn:large:vision"],
      contextLength: 262144,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
      supportsVision: true,
    },
    {
      id: "hf:Qwen/Qwen3.6-27B",
      name: "Qwen/Qwen3.6-27B",
      aliases: ["syn:small:vision"],
      contextLength: 262144,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
      supportsVision: true,
    },
    {
      id: "hf:MiniMaxAI/MiniMax-M3",
      name: "MiniMaxAI/MiniMax-M3",
      aliases: ["syn:minimax-m3"],
      contextLength: 262144,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
      supportsVision: true,
    },
    {
      id: "hf:zai-org/GLM-4.7-Flash",
      name: "zai-org/GLM-4.7-Flash",
      aliases: ["syn:small:text"],
      contextLength: 196608,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
    },
    {
      id: "hf:nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-NVFP4",
      name: "nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-NVFP4",
      aliases: ["syn:nemotron-3-super"],
      contextLength: 262144,
      maxOutputTokens: 65536,
      toolCalling: true,
      supportsReasoning: true,
    },
  ],
  passthroughModels: true,
};
